module.exports = __webpack_public_path__ + "images/花筑村全景_04-3.jpg?v=f265f3c8";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_04-3.jpg
 ** module id = 91
 ** module chunks = 1 2
 **/